import { Avatar, Card, Button } from 'antd';
import { Hitch, Status, StatusTranslations } from '../../services/apps/hitches';
import React from 'react';
import LinkAnotherAppInsideCard from 'components/LinkAnotherAppInsideCard';
import { CloseCircleOutlined } from '@ant-design/icons';
import styles from './styles.module.css';
import Link from 'next/link';
import { UrlObject } from 'url';
import InfoTag from 'components/InfoTag';
import { useIntl } from 'react-intl';

function formatSupported(status: Status, statusText: string) {
  if (!status) {
    return '';
  }

  function getTagColor() {
    switch (status) {
      case 'supported':
        return 'green';
      case 'planning':
        return 'gold';
      case 'pipeline':
        return 'orange';
      default:
        return 'red';
    }
  }

  return <InfoTag style={{ float: 'right' }} color={getTagColor()} text={statusText} />;
}

const HitchDetailSummary = ({
  hitch,
  otherHitch,
  overview,
  onSelect,
  deletable,
}: {
  hitch?: Hitch;
  otherHitch?: Hitch;
  overview?: UrlObject;
  onSelect?: (selected?: string) => void;
  deletable?: boolean;
}): JSX.Element => {
  const { formatMessage } = useIntl();
  if (!hitch) {
    if (!onSelect) {
      throw new Error('onSelect is mandatory when no hitch');
    }
    return <LinkAnotherAppInsideCard otherHitch={otherHitch} onSelect={onSelect} />;
  }

  function createDeleteButton() {
    if (!deletable) {
      return;
    }
    if (!onSelect) {
      throw new Error('onSelect is mandatory when deletable');
    }
    return (
      <Button
        size="large"
        style={{ position: 'absolute', right: '11px', top: '0' }}
        type="link"
        onClick={() => onSelect()}
        icon={<CloseCircleOutlined key="hitch" style={{ fontSize: '22px' }} />}
      />
    );
  }

  const hitchDetailSummaryCard = (
    <Card
      className={styles.card}
      hoverable
      // bodyStyle={{ paddingBottom: 20 }}
      // actions={[
      //   // TODO JDI add like + subscribe logic
      //   <Button
      //     key="like"
      //     type="text"
      //     size="large"
      //     onClick={() => {
      //       console.log(hitch.id);
      //     }}
      //   >
      //     <Tooltip key="heart" title="like it">
      //       <HeartOutlined />
      //     </Tooltip>
      //   </Button>,
      //   // TODO JDI add share it logic
      //   <Button
      //     key="share"
      //     type="text"
      //     size="large"
      //     onClick={() => {
      //       console.log(hitch.id);
      //     }}
      //   >
      //     <Tooltip title="share it" key="share">
      //       <ShareAltOutlined />
      //     </Tooltip>
      //   </Button>,
      // ]}
    >
      <Card.Meta
        avatar={<Avatar size="large" src={hitch.icon} />}
        title={hitch.name}
        description={
          !overview &&
          formatSupported(hitch.status, formatMessage(StatusTranslations[hitch.status]))
        }

        // description={<div style={{ height: '120px' }}>{hitch.tagline}</div>}
      />
      {/* <div>
  <CardInfo
    category={formatCategories(hitch.category)}
    status={formatSupported(hitch.status)}
  />
</div> */}
    </Card>
  );

  if (overview) {
    return <Link href={overview}>{hitchDetailSummaryCard}</Link>;
  }

  return (
    <>
      {hitchDetailSummaryCard}
      {createDeleteButton()}
    </>
  );
};
export default HitchDetailSummary;
